<template>
  <div class="account">
    <div class="account-title">{{ $t('receiveFunding') }}</div>
    <div class="account-wrap">
      <div class="account-card">
        <div class="account-card__left">
          <img src="../../assets/img/xpay.png" alt="" />
          <span>XPR</span>
        </div>
        <div class="account-card__right">
          <span>XPR {{ $t('account') }}</span>
          <div class="account-card__qrcode">
            <img width="250" height="250" :src="xPayBalance.qr_code" />
          </div>
        </div>
      </div>
      <div class="account-action">
        <CopyButton :value="walletInfo.address"></CopyButton>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CopyButton from '@/components/CopyButton'
export default {
  name: 'wallet-send-receive',
  data () {
    return {}
  },
  components: {
    CopyButton
  },
  metaInfo () {
    return {
      title: this.$t('titleWallet')
    }
  },
  computed: {
    ...mapGetters({
      xPayBalance: 'wallet/xPayBalance',
      walletInfo: 'wallet/walletInfo',
      user: 'auth/user'
    })
  },
  methods: {
    ...mapActions({
      getUserIdReq: 'wallet/getUserId',
      fetchBalance: 'wallet/fetchBalance',
      transferFunds: 'wallet/transferFunds'
    })
  }
}
</script>

<style lang="scss" scoped>
.account {
  padding-right: 15px;
  max-height: 565px;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 8px;
    position: absolute;
    background: rgba(17, 17, 17, 0.1);
  }
  &::-webkit-scrollbar-track {
    background: transparent;
    position: absolute;
    z-index: -2;
  }
  &::-webkit-scrollbar-thumb {
    background: #00b764;
    border-radius: 5px;
  }
  &-title {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  &-wrap {
    margin-top: 30px;
  }
  &-card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 400px;
    height: auto;
    padding: 20px 15px;
    border-radius: 15px;
    background-color: #232f3f;
    margin: 0 auto;
    user-select: none;
    &__left {
      width: 40%;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      span {
        display: inline-block;
        position: absolute;
        left: 10px;
        bottom: 20px;
        color: $white;
        font-size: 26px;
      }
    }
    &__right {
      width: 60%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      height: 100%;
      margin-top: 30px;
      span {
        color: $white;
        font-size: 20px;
        margin-bottom: 10px;
      }
    }
    &__qrcode {
      width: 250px;
      height: 250px;
      @include respondTo(350px) {
        width: 200px;
        height: 200px;
      }
      img {
        width: 250px;
        height: 250px;
        object-fit: cover;
        @include respondTo(350px) {
          width: 200px;
          height: 200px;
        }
      }
    }
  }
  &-action {
    width: 100%;
    max-width: 300px;
    margin: 20px auto;
    button {
      width: 100%;
      padding: 15px 30px;
      background: #f7961d;
      color: $white;
      font-size: 16px;
      font-weight: bold;
      height: 50px;
      &.button--loading {
        background: #f7961d;
      }
      &.button--disabled {
        opacity: 0.5;
      }
    }
  }
  &-send {
    &__title {
      font-size: 14px;
      text-align: center;
      font-weight: bold;
      margin: 15px 0;
    }
    &__type {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      margin: 15px 0;
      .radio {
        width: 40%;
        height: 40px;
        border: 1px solid #cecece;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
  &-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    label {
      width: 100%;
    }
    &__fee {
      background-color: #b6babe;
      height: 40px;
      width: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      margin-top: 24px;
      font-size: 12px;
      font-weight: 500;
      span {
        margin-right: 3px;
        font-size: 12px;
      }
    }
  }
  .account-label {
    display: flex;
    flex-direction: row;
    padding: 5px 0;
    cursor: pointer;
    font-weight: 500;
    position: relative;
    overflow: hidden;
    margin-bottom: 0.375em;
    input {
      position: absolute;
      left: -9999px;
      &:checked + span {
        background-color: mix(#fff, $green, 84%);
        &:before {
          box-shadow: inset 0 0 0 0.4375em $green;
        }
      }
    }
    span {
      display: flex;
      align-items: center;
      padding: 0.375em 0.75em 0.375em 0.375em;
      border-radius: 99em; // or something higher...
      transition: 0.25s ease;
      &:hover {
        background-color: mix(#fff, $green, 84%);
      }
      &:before {
        display: flex;
        flex-shrink: 0;
        content: '';
        background-color: #fff;
        width: 1.5em;
        height: 1.5em;
        border-radius: 50%;
        margin-right: 0.375em;
        transition: 0.25s ease;
        box-shadow: inset 0 0 0 0.125em $green;
      }
    }
  }
}
</style>
<style lang="scss">
.account-send__type .radio {
  background: #00b764;
  color: $white;
  cursor: pointer;
  label {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    span {
      margin-right: 10px !important;
    }
  }
}
.option-row {
  display: flex;
  flex-direction: column !important;
  .account-option {
    padding: 15px 10px;
  }
  .radio {
    width: 100%;
    padding: 5px 0;
  }
}
</style>
